var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._l((_vm.datasets),function(dataset,index){return _c('svg-wave-lines',{key:dataset.name,attrs:{"d":dataset,"o":_vm.options,"points":_vm.points[index],"svg":_vm.svg}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }